import { QuestionReference } from '../core/api/bingliApi'

export const languages: Record<string, string> = { nl: 'nl-be', fr: 'fr-be', en: 'en-us' }
export const questionsCodexPromise: Promise<Record<string, QuestionReference>> = fetch('/form/questions.json').then((response) => response.json())
export const answerLabelToLabelPromise: Promise<Record<string, string[]>> = fetch('/form/answerLabelToLabel.json').then((response) => response.json())
export const questionCodeToLabelPromise: Promise<Record<string, string>> = fetch('/form/questionCodeToLabel.json').then((response) => response.json())
export const questionLabelToLabelPromise: Promise<Record<string, string>> = fetch('/form/questionLabelToLabel.json').then((response) => response.json())
export const translationsPromise: Promise<Record<string, Record<string, Record<string, string>>>> = fetch('/report/translations.json')
  .then((response) => response.json() as Promise<Record<string, Record<string, Record<string, string>>>>)
  .then(async (translations) => {
    const codex = await questionsCodexPromise
    Object.values(codex).forEach((question) => {
      Object.values(question.options ?? {}).forEach((option) => {
        if (option.code) {
          if (option.fr) {
            const fr = translations['fr'] ?? (translations['fr'] = {})
            ;(fr['codex'] ?? (fr['codex'] = {}))[option.code] = option.fr
          }
          if (option.nl) {
            const nl = translations['nl'] ?? (translations['nl'] = {})
            ;(nl['codex'] ?? (nl['codex'] = {}))[option.code] = option.nl
          }
          if (option.en) {
            const en = translations['en'] ?? (translations['en'] = {})
            ;(en['codex'] ?? (en['codex'] = {}))[option.code] = option.en
          }
        }
      })
    })
    return translations
  })
